import { TextInput } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

import { useInvoiceFormContext } from '../InvoiceForm.context';

export const OrderReferenceField = () => {
  const { t } = useTranslation();
  const form = useInvoiceFormContext();

  return (
    <TextInput
      {...form.getInputProps('order_reference')}
      placeholder={t(i18nKeys.INVOICING.CREATE.ORDER_REFERENCE)}
      size="xs"
    />
  );
};
